var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"settings-page",attrs:{"padding":""}},[_c('PeerGroupForm',{attrs:{"is-edit":true,"peer-group-id":_vm.peerGroupId,"back-location":{ name: 'settings:peer-group' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }